import { UserStatus, UserDetail } from 'api'
import { Locale } from 'locale'
import { userStatusTranslationMap } from 'model'
import * as constants from 'view/styles/constants'

export function getUserStatusColor(userDetail: UserDetail): string {
  return userDetail.user.status === UserStatus.ACTIVE ? constants.STATUS_COLOR_READY : constants.STATUS_COLOR_DEFAULT
}

export function getUserStatusText(userDetail: UserDetail): string {
  return Locale.translate(userStatusTranslationMap[userDetail.user.status])
}
